// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 10px;
  background: var(--main-background);
  margin: 0;
  overflow: hidden;
}

.title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.06em;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
}

.info {
  font-family: AppFont, sans-serif;
  font-size: 12px;
  margin: 5px 0px 10px;
  letter-spacing: 0.02em;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
}

.button {
  height: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 26px;
  text-transform: uppercase;
  font-family: AppFont !important;
  max-width: 150px;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: var(--accent-color);
  font-size: var(--buttons-font-size);
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: #fff;
}
.button_main:hover {
  background: #a9715c;
}
.button_close {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 14px;
  min-height: 25px;
  text-align: center;
  margin: 0;
  text-transform: var(--buttons-text-transform);
  color: #fff;
}
.button_close:hover {
  background: rgba(255, 255, 255, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/app/components/change-venue-popover/change-venue-popover.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,SAAA;EAGA,gBAAA;AADJ;;AAIE;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAFJ;;AAKE;EACE,gCAAA;EACA,eAAA;EACA,oBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,+BAAA;EACA,yBAAA;AAHJ;;AAOE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AAJJ;AAKI;EACE,gBAAA;AAHN;AAKI;EACE,+BAAA;EACA,mCAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AAJN;AAMM;EACE,mBAAA;AAJR;AAQI;EACE,uBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EAEA,SAAA;EACA,6CAAA;EACA,WAAA;AAPN;AASM;EACE,qCAAA;AAPR","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 10px 10px;\n    background: var(--main-background);\n    margin: 0;\n\n\n    overflow: hidden;\n  }\n\n  .title {\n    font-family: AppFont, sans-serif;\n    font-size: 16px;\n    font-weight: bold;\n\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: #fff;\n    text-transform: uppercase;\n  }\n\n  .info {\n    font-family: AppFont, sans-serif;\n    font-size: 12px;\n    margin: 5px 0px 10px;\n\n    letter-spacing: 0.02em;\n    text-align: center;\n    color: rgba(255, 255, 255, 0.8);\n    text-transform: uppercase;\n\n  }\n\n  .button {\n    height: 25px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    border-radius: 26px;\n    text-transform: uppercase;\n    font-family: AppFont !important;\n    max-width: 150px;\n    cursor: pointer;\n    &:last-child {\n      margin-bottom: 0;\n    }\n    &_main {\n      background: var(--accent-color);\n      font-size: var(--buttons-font-size);\n\n      font-size: 14px;\n      line-height: 25px;\n      letter-spacing: 0.06em;\n      text-align: center;\n      color: #fff;\n\n      &:hover {\n        background: #a9715c;\n      }\n    }\n\n    &_close {\n      background: transparent;\n      border: 1px solid rgba(255, 255, 255, 0.3);\n      font-size: 14px;\n      min-height: 25px;\n      text-align: center;\n\n      margin: 0;\n      text-transform: var(--buttons-text-transform);\n      color: #fff;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.08);\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
